import InterHospiSuperPlatform from '@/pages/interHospiSuperPlatform';
import AdministrativeCode from '@/pages/interHospiSuperPlatform/administrativeCode';
import CatalogueMedicalItem from '@/pages/interHospiSuperPlatform/catalogueMedicalItem';
import DiseaseClassifyCode from '@/pages/interHospiSuperPlatform/diseaseClassifyCode';
import DrugCatalog from '@/pages/interHospiSuperPlatform/drugCatalog';
import MedicalInsurance from '@/pages/medicalInsurance';
import ChineseMedicine from '@/pages/medicalInsurance/chineseMedicine';
import PcMedicine from '@/pages/medicalInsurance/pcMedicine';
import NationalMedicalBureau from '@/pages/nationalMedicalBureau';
import React, { lazy } from 'react';
import { Navigate } from 'react-router-dom';
import Home from '../pages/home';
import Login from '../pages/user/login';
import NoFind from '../pages/user/noFind';
import Password from '../pages/user/password';
// import ProjectAdd from '@/pages/weapp/projectAdd';

// 懒加载只能针对挂载在Home组件下的组件，因为Suspense组件放在Home中
const OrganList = lazy(() => import('../pages/setting/organList'));
const UserList = lazy(() => import('../pages/setting/userList'));
const Message = lazy(() => import('../pages/message'));
const TenantList = lazy(() => import('../common/pages/customer/tenant'));
const CustomerOrganList = lazy(() => import('../common/pages/customer/organ'));
const CustomerOrganDetail = lazy(() => import('../common/pages/customer/organ/detail'));
const DepartmentList = lazy(() => import('../common/pages/customer/department'));
const CustomerRoleList = lazy(() => import('../common/pages/customer/role'));
const CustomerEmployeesList = lazy(() => import('../common/pages/customer/employees'));
// 权限管理
const ResourceAdmin = lazy(() => import('../pages/rootAdmin/resourceAdmin'));
const ApplicationAdmin = lazy(() => import('../pages/rootAdmin/applicationAdmin'));
const MiniAppAdmin = lazy(() => import('../pages/rootAdmin/miniAppAdmin'));
const MenuAdmin = lazy(() => import('../pages/rootAdmin/menuAdmin'));
const ModuleAdmin = lazy(() => import('../pages/rootAdmin/moduleAdmin'));
const UserAdmin = lazy(() => import('../pages/rootAdmin/userAdmin'));
const UserRecord = lazy(() => import('../pages/rootAdmin/userAdmin/userRecord'));
const LogAdmin = lazy(() => import('../pages/rootAdmin/logAdmin'));
const BusinessAdmin = lazy(() => import('../pages/rootAdmin/businessAdmin'));
// 标签管理
const LabelTypeAdmin = lazy(() => import('../pages/labelsAdmin/labelTypeAdmin'));
const LabelLibrary = lazy(() => import('../pages/labelsAdmin/labelLibrary'));
// 客户管理
const TenantAdmin = lazy(() => import('../pages/customerAdmin/tenantAdmin'));
const OrganizationAdmin = lazy(() => import('../pages/customerAdmin/organizationsAdmin'));
const DepartmentAdmin = lazy(() => import('../pages/customerAdmin/departmentAdmin'));
const RoleAdmin = lazy(() => import('../pages/customerAdmin/roleAdmin'));

// 支付管理
const PayBusiness = lazy(() => import('../pages/payManage/business'));
const PayChannel = lazy(() => import('../pages/payManage/channel'));
// 通知管理
const Channel = lazy(() => import('../pages/noticeAdmin/channel'));
const ClassPages = lazy(() => import('../pages/noticeAdmin/classPages'));
const TemplatePages = lazy(() => import('../pages/noticeAdmin/templatePages'));
const BusinessNotice = lazy(() => import('../pages/noticeAdmin/businessNotice'));
const Deactivate = lazy(() => import('../pages/noticeAdmin/deactivate'));
const AppMessage = lazy(() => import('../pages/noticeAdmin/appMessage'));
const SystemList = lazy(() => import('../pages/noticeAdmin/systemList'));

// 中康数据中台
const DataCenter = lazy(() => import('../pages/dataCenter'));
const DrugBusiness = lazy(() => import('../pages/dataCenter/drugBusiness'));
const DrugListcfda = lazy(() => import('../pages/dataCenter/drugListcfda'));
const DrugCommonName = lazy(() => import('../pages/dataCenter/drugCommonName'));
const DrugBarcode = lazy(() => import('../pages/dataCenter/drugBarcode'));

// 西医手术
const SurgeryId9 = lazy(() => import('@/pages/surgery/id9'));
const SurgeryIcd10 = lazy(() => import('@/pages/surgery/id10'));
const TcmDiseases = lazy(() => import('@/pages/surgery/tcmDiseases'));
const TcmSyndrome = lazy(() => import('@/pages/surgery/tcmSyndrome'));
const MedicalService = lazy(() => import('@/pages/medicalInsurance/medicalService'));
const Consumables = lazy(() => import('@/pages/medicalInsurance/consumables'));

// 企微管理
const WordWecharApp = lazy(() => import('@/pages/wordWechar/app'));
const WordWecharAuth = lazy(() => import('@/pages/wordWechar/auth'));
const WordWecharTemplate = lazy(() => import('@/pages/wordWechar/template'));
const WordWecharFirm = lazy(() => import('@/pages/wordWechar/firm'));

//////////////////////////////////////////////////////////////
// const StaffAdmin = lazy(() => import('../pages/customerAdmin/staffAdmin'));
// const WeappColumn = lazy(() => import('../pages/weapp/column'));
// const WeappProject = lazy(() => import('../pages/weapp/project'));
// const OrganList = lazy(() => import('../pages/setting/organList'));
// const UserList = lazy(() => import('../pages/setting/userList'));
// const Message = lazy(() => import('../pages/message'));
// const FollowList = lazy(() => import('../pages/follow/list'));
// const FollowCount = lazy(() => import('../pages/follow/count'));

export type routerConfigItem = {
  path: string;
  code?: string;
  element?: React.ReactNode;
  hideInMenu?: boolean;
  children?: routerConfigItem[];
  meta?: any;
};
export const baseRouterConfig = [
  {
    path: '/login',
    element: <Login />,
  },
  {
    path: '/password',
    element: <Password />,
  },
  {
    path: '*',
    element: <NoFind />,
  },
];
const routerConfig: routerConfigItem[] = [
  {
    path: '/',
    element: <Home />,
    code: '',
    children: [
      {
        path: '/',
        element: <Navigate to="/rootAdmin/resourceAdmin" replace />,
      },
      {
        path: '/rootAdmin/resourceAdmin',
        element: <ResourceAdmin />,
        // 加code，与后端返回的code对应，有则显示，没有则删除
        code: 'ResourceAdmin',
      },
      {
        path: '/rootAdmin/applicationAdmin',
        element: <ApplicationAdmin />,
        code: 'ApplicationAdmin',
      },
      {
        path: '/rootAdmin/miniAppAdmin',
        element: <MiniAppAdmin />,
        code: 'MiniAppAdmin',
      },
      {
        path: '/rootAdmin/menuAdmin',
        element: <MenuAdmin />,
        code: 'MenuAdmin',
      },
      {
        path: '/rootAdmin/moduleAdmin',
        element: <ModuleAdmin />,
        code: 'ModuleAdmin',
      },
      {
        path: '/rootAdmin/userAdmin',
        element: <UserAdmin />,
        code: 'UserAdmin',
      },
      {
        path: '/rootAdmin/userAdmin/userRecord',
        element: <UserRecord />,
        code: 'UserRecord',
      },
      {
        path: '/rootAdmin/logAdmin',
        element: <LogAdmin />,
        code: 'LogAdmin',
      },
      {
        path: '/rootAdmin/businessAdmin',
        element: <BusinessAdmin />,
        code: 'BusinessAdmin',
      },
      {
        path: '/rootAdmin/wordWechar/app',
        element: <WordWecharApp />,
        code: 'WordWecharApp',
      },
      {
        path: '/rootAdmin/wordWechar/auth',
        element: <WordWecharAuth />,
        code: 'WordWecharAuth',
      },
      {
        path: '/rootAdmin/wordWechar/template',
        element: <WordWecharTemplate />,
        code: 'WordWecharTemplate',
      },
      {
        path: '/rootAdmin/wordWechar/firm',
        element: <WordWecharFirm />,
        code: 'WordWecharFirm',
      },
      {
        path: '/labelsAdmin/labelTypeAdmin',
        element: <LabelTypeAdmin />,
        code: 'LabelTypeAdmin',
      },
      {
        path: '/labelsAdmin/labelLibrary',
        element: <LabelLibrary />,
        code: 'LabelLibrary',
      },
      {
        path: '/customerAdmin/tenantAdmin',
        element: <TenantAdmin />,
        code: 'TenantAdmin',
      },
      {
        path: '/customerAdmin/organizationAdmin',
        element: <OrganizationAdmin />,
        code: 'OrganizationAdmin',
      },
      {
        path: '/customerAdmin/departmentAdmin',
        element: <DepartmentAdmin />,
        code: 'DepartmentAdmin',
      },
      {
        path: '/customerAdmin/roleAdmin',
        element: <RoleAdmin />,
        code: 'RoleAdmin',
      },
      {
        path: '/customer/tenant',
        element: <TenantList />,
        code: 'TenantList',
      },
      {
        path: '/customer/organ',
        element: <CustomerOrganList />,
        code: 'CustomerOrganList',
      },
      {
        path: '/customer/organ/detail',
        element: <CustomerOrganDetail />,
        code: 'CustomerOrganDetail',
      },
      {
        path: '/customer/department',
        element: <DepartmentList />,
        code: 'DepartmentList',
      },
      {
        path: '/customer/role',
        element: <CustomerRoleList />,
        code: 'CustomerRoleList',
      },
      {
        path: '/customer/employees',
        element: <CustomerEmployeesList />,
        code: 'CustomerEmployeesList',
      },
      {
        path: '/payManage/business',
        element: <PayBusiness />,
        code: 'PayBusinessList',
      },
      {
        path: '/payManage/channel',
        element: <PayChannel />,
        code: 'PayChannelList',
      },
      {
        path: '/noticeAdmin/channel',
        element: <Channel />,
        code: 'NoticeAdminChannel',
      },
      {
        path: '/noticeAdmin/classPages',
        element: <ClassPages />,
        code: 'NoticeAdminClassPages',
      },
      {
        path: '/noticeAdmin/templatePages',
        element: <TemplatePages />,
        code: 'TemplatePages',
      },
      {
        path: '/noticeAdmin/businessNotice',
        element: <BusinessNotice />,
        code: 'BusinessNotice',
      },
      {
        path: '/noticeAdmin/deactivate',
        element: <Deactivate />,
        code: 'Deactivate',
      },
      {
        path: '/noticeAdmin/appMessage',
        element: <AppMessage />,
        code: 'AppMessage',
      },
      {
        path: '/noticeAdmin/systemList',
        element: <SystemList />,
        code: 'SystemList',
      },
      {
        path: '/datamanagement/datalake/nationalMedicalBureau',
        element: <NationalMedicalBureau />,
        code: 'NatiMedicalBureau',
      },
      {
        path: '/datamanagement/datalake/platform',
        element: <InterHospiSuperPlatform />,
        code: 'InterHospi',
      },
      {
        path: '/datamanagement/datalake/platform/diseaseClassifyCode',
        element: <DiseaseClassifyCode />,
        // code: 'DiseaseClassify',
      },
      {
        path: '/datamanagement/datalake/platform/catalogueMedicalItem',
        element: <CatalogueMedicalItem />,
        // code: 'CatalogueMedical',
      },
      {
        path: '/datamanagement/datalake/platform/administrativeCode',
        element: <AdministrativeCode />,
        // code: 'AdministrCode',
      },
      {
        path: '/datamanagement/datalake/platform/drugCatalog',
        element: <DrugCatalog />,
        // code: 'DrugCatalog',
      },
      {
        path: '/datamanagement/datalake/medicalInsurance',
        element: <MedicalInsurance />,
        code: 'MedicalInsurance',
      },
      {
        path: '/datamanagement/datalake/medicalInsurance/pcMedicine',
        element: <PcMedicine />,
        // code: 'pcMedicine',
      },
      {
        path: '/datamanagement/datalake/medicalInsurance/chineseMedicine',
        element: <ChineseMedicine />,
        // code: 'chineseMedicine',
      },
      {
        path: '/datamanagement/datalake/dataCenter',
        element: <DataCenter />,
        code: 'DataCenter',
      },
      {
        path: '/datamanagement/datalake/dataCenter/drugBusiness',
        element: <DrugBusiness />,
        // code: '',
      },
      {
        path: '/datamanagement/datalake/dataCenter/drugListcfda',
        element: <DrugListcfda />,
        // code: '',
      },
      {
        path: '/datamanagement/datalake/dataCenter/drugBarcode',
        element: <DrugBarcode />,
        // code: '',
      },
      {
        path: '/datamanagement/datalake/dataCenter/drugCommonName',
        element: <DrugCommonName />,
        // code: '',
      },
      {
        path: '/datamanagement/datalake/medicalInsurance/consumables',
        element: <Consumables />,
      },
      {
        path: '/datamanagement/datalake/medicalInsurance/medicalService',
        element: <MedicalService />,
      },
      {
        path: '/datamanagement/datalake/medicalInsurance/surgeryIcd9',
        element: <SurgeryId9 />,
      },
      {
        path: '/datamanagement/datalake/medicalInsurance/surgeryIcd10',
        element: <SurgeryIcd10 />,
      },
      {
        path: '/datamanagement/datalake/medicalInsurance/tcmDiseases',
        element: <TcmDiseases />,
      },
      {
        path: '/datamanagement/datalake/medicalInsurance/tcmSyndrome',
        element: <TcmSyndrome />,
      },
    ],
  },
  ...baseRouterConfig
];

// todo: 与路由表结合生成面包屑地图数据
export const breadcrumbMap = {
  customer: {
    label: '客户管理',
    path: '/customer/tenant',
    tenant: {
      label: '租户管理',
      path: '/customer/tenant',
    },
    organ: {
      label: '组织管理',
      path: '/customer/organ',
      detail: {
        label: '组织详情',
        path: '/customer/organ/detail',
      },
    },
    department: {
      label: '部门管理',
      path: '/customer/department',
    },
    role: {
      label: '角色管理',
      path: '/customer/role',
    },
    employees: {
      label: '员工管理',
      path: '/customer/employees',
    },
  },
  rootAdmin: {
    label: '权限管理',
    path: '/rootAdmin/resourceAdmin',
    resourceAdmin: {
      label: '资源管理',
      path: '/rootAdmin/resourceAdmin',
    },
    applicationAdmin: {
      label: '应用管理',
      path: '/rootAdmin/applicationAdmin',
      add: {
        label: '添加应用',
        path: '/rootAdmin/applicationAdmin/add',
      },
      edit: {
        label: '编辑应用',
        path: '/rootAdmin/applicationAdmin/edit',
      },
    },
    miniAppAdmin: {
      label: '小程序管理',
      path: '/rootAdmin/miniAppAdmin',
    },
    menuAdmin: {
      label: '菜单管理',
      path: '/rootAdmin/menuAdmin',
    },
    moduleAdmin: {
      label: '模块管理',
      path: '/rootAdmin/moduleAdmin',
    },
    userAdmin: {
      label: '用户管理',
      path: '/rootAdmin/userAdmin',
      userRecord: {
        label: '用户登录记录',
        path: '/rootAdmin/userAdmin/userRecord',
      },
    },
    logAdmin: {
      label: '日志管理',
      path: '/rootAdmin/logAdmin',
    },
    businessAdmin: {
      label: '业务管理',
      path: '/rootAdmin/businessAdmin',
    },
    wordWechar: {
      label: '企业微信管理',
      app: {
        label: '企微应用管理',
        path: '/rootAdmin/wordWechar/app',
      },
      auth: {
        label: '企微授权登录管理',
        path: '/rootAdmin/wordWechar/auth',
      },
      template: {
        label: '代开发应用模板管理',
        path: '/rootAdmin/wordWechar/template',
      },
      firm: {
        label: '授权服务商企业信息',
        path: '/rootAdmin/wordWechar/firm',
      },
    }
  },
  labelsAdmin: {
    label: '标签管理',
    path: '/labelsAdmin/labelTypeAdmin',
    labelTypeAdmin: {
      label: '标签管理',
      path: '/labelsAdmin/labelTypeAdmin',
    },
    // labelLibrary: {
    //   label: '标签库管理',
    //   path: '/labelsAdmin/labelLibrary',
    // },
  },
  payManage: {
    label: '支付管理',
    path: '/payManage/business',
    business: {
      label: '支付业务管理',
      path: '/payManage/business',
    },
  },
  noticeAdmin: {
    label: '通知管理',
    path: '/noticeAdmin/channel',
    channel: {
      label: '通知渠道管理',
      path: '/noticeAdmin/channel',
    },
    classPages: {
      label: '通知类型管理',
      path: '/noticeAdmin/classPages',
    },
    templatePages: {
      label: '通知模板管理',
      path: '/noticeAdmin/templatePages',
    },
    businessNotice: {
      label: '业务通知管理',
      path: '/noticeAdmin/businessNotice',
    },
    deactivate: {
      label: '通知停用管理',
      path: '/noticeAdmin/deactivate',
    },
    appMessage: {
      label: '应用消息管理',
      path: '/noticeAdmin/appMessage',
    },
    systemList: {
      label: '系统黑白名单',
      path: '/noticeAdmin/systemList',
    },
  },
  datamanagement: {
    label: '数据管理',
    path: '/datamanagement/datalake/medicalInsurance',
    datalake: {
      label: '数据湖',
      path: '/datamanagement/datalake/medicalInsurance',
      platform: {
        label: '互联网医院监管平台',
        path: '/datamanagement/datalake/platform',

        drugCatalog: {
          label: '国家药品供应保障综合管理信息平台药品目录',
          path: '/datamanagement/datalake/platform/drugCatalog',
        },
        diseaseClassifyCode: {
          label: '疾病分类与代码（2019）',
          path: '/datamanagement/datalake/platform/diseaseClassifyCode',
        },
        catalogueMedicalItem: {
          label: '医疗服务收费项目医保目录',
          path: '/datamanagement/datalake/platform/catalogueMedicalItem',
        },
        administrativeCode: {
          label: '2018年行政区化码',
          path: '/datamanagement/datalake/platform/administrativeCode',
        },
      },
      medicalInsurance: {
        label: '国家医保局',
        path: '/datamanagement/datalake/medicalInsurance',
        consumables: {
          label: '医保医药耗材数据库',
          path: '/datamanagement/datalake/medicalInsurance/consumables',
        },
        medicalService: {
          label: '全国医疗服务项目',
          path: '/datamanagement/datalake/medicalInsurance/medicalService',
        },
        surgeryIcd9: {
          label: '西医手术 ICD-9-CM3 医保 2.0 版',
          path: '/datamanagement/datalake/medicalInsurance/surgeryIcd9',
        },
        surgeryIcd10: {
          label: '西医疾病 ICD-10 医保 2.0 版',
          path: '/datamanagement/datalake/medicalInsurance/surgeryIcd10',
        },
        tcmDiseases: {
          label: '中医疾病医保 2.0 版',
          path: '/datamanagement/datalake/medicalInsurance/tcmDiseases',
        },
        tcmSyndrome: {
          label: '中医证候医保 2.0 版',
          path: '/datamanagement/datalake/medicalInsurance/tcmSyndrome',
        },
        pcMedicine: {
          label: '医保药品数据库 (西药+中成药)',
          path: '/datamanagement/datalake/medicalInsurance/pcMedicine',
        },
        chineseMedicine: {
          label: '医保药品数据库（中药饮片）',
          path: '/datamanagement/datalake/medicalInsurance/chineseMedicine',
        },
      },
      nationalMedicalBureau: {
        label: '国家医政医管局',
        path: '/datamanagement/datalake/nationalMedicalBureau',
      },
      dataCenter: {
        label: '中康数据中台',
        path: '/datamanagement/datalake/dataCenter',
        drugListcfda: {
          label: 'CFDA 药品表',
          path: '/datamanagement/datalake/dataCenter/drugListcfda',
        },
        drugBusiness: {
          label: '药品业务信息表',
          path: '/datamanagement/datalake/dataCenter/drugBusiness',
        },
        drugCommonName: {
          label: '药品通用名信息表',
          path: '/datamanagement/datalake/dataCenter/drugCommonName',
        },
        drugBarcode: {
          label: '药品条形码',
          path: '/datamanagement/datalake/dataCenter/drugBarcode',
        },
      },
    },
  },
};

function mapRouterConfig(config: routerConfigItem[], fn: any, parentPath = '') {
  config.forEach((item) => {
    fn && fn(item, parentPath);
    if (item.children) {
      const en = item.path.startsWith('/') || parentPath.endsWith('/') ? '' : '/';
      mapRouterConfig(item.children, fn, parentPath + en + item.path);
    }
  });
}

const hideInMenuPages: string[] = [];

mapRouterConfig(routerConfig, (router: routerConfigItem, parentPath: string) => {
  // console.log(router);
  // console.log(parentPath);
  if (router.hideInMenu) {
    const en = router.path.startsWith('/') || parentPath.endsWith('/') ? '' : '/';
    hideInMenuPages.push(parentPath + en + router.path);
  }
});

export { hideInMenuPages };
export default routerConfig;
